import { ApolloError } from '@apollo/client';

import ErrorMessage, {
  ErrorMessageProps,
} from 'approot/shared/error-message/error-message';
import { PUBLIC_CONTACT_US } from 'global/public-routes.constants';
import { getServerErrorMessage, isCardDeclinedError } from 'lib/apollo.utils';
import {
  AnchorLinkErrorStyled,
  LinkStyled,
  PStyled,
} from 'approot/shared/styles/typography.style';

// TODO: move inline errors outside of account as they can be used elsewhere too

type InlineServerErrorProps = {
  customError?: string;
} & ErrorMessageProps;

export const InlineServerError = ({
  customError,
  ...props
}: InlineServerErrorProps) => {
  return customError ? (
    <ErrorMessage {...props}>{customError}</ErrorMessage>
  ) : (
    <ErrorMessage {...props}>
      Something went wrong, please try again or{' '}
      <AnchorLinkErrorStyled to={PUBLIC_CONTACT_US}>
        contact us
      </AnchorLinkErrorStyled>
    </ErrorMessage>
  );
};
type InlineApolloErrorProps = {
  error: ApolloError;
} & ErrorMessageProps;

export const InlineApolloError = ({
  error,
  ...props
}: InlineApolloErrorProps) => {
  const message = getServerErrorMessage(error);
  if (message) {
    return <InlineDetailedError details={message} error={error} {...props} />;
  }
  return <InlineServerError {...props} />;
};

type InlineDetailedErrorProps = {
  error?: ApolloError;
  details?: string;
} & ErrorMessageProps;

export const InlineDetailedError = ({
  details,
  error,
  ...props
}: InlineDetailedErrorProps) => {
  const isCardDeclined = isCardDeclinedError(error);

  return (
    <ErrorMessage {...props}>
      {details ? <>An error occurred: {details}</> : 'Something went wrong.'}
      <br />
      {isCardDeclined ? (
        <>
          Please double-check your payment details or reach out to your card
          provider for assistance.
        </>
      ) : (
        <>
          Please try again or{' '}
          <AnchorLinkErrorStyled to={PUBLIC_CONTACT_US}>
            contact us
          </AnchorLinkErrorStyled>
        </>
      )}
    </ErrorMessage>
  );
};

const renderContactUs = () => {
  return (
    <>
      If this problem persists, please{' '}
      <LinkStyled to={PUBLIC_CONTACT_US}>contact us</LinkStyled>.
    </>
  );
};

export const PageServerError = ({
  messagePrefix,
  showContactUs = true,
}: {
  messagePrefix: string;
  showContactUs?: boolean;
}) => {
  return (
    <div>
      <PStyled textAlignCenter>
        {messagePrefix}. {showContactUs && renderContactUs()}
      </PStyled>
    </div>
  );
};
